import React from 'react';
import { NavLink } from 'react-router-dom';
// Using clean, outlined icons for a modern feel
import { FaUniversity, FaCertificate, FaChalkboardTeacher } from 'react-icons/fa';
import './HomeAbout.css';

import img from '../../../assets/SKTT.jpg';

// The key points for the right-hand column
const keyPoints = [
  {
    icon: <FaUniversity />,
    text: "A premier co-educational institution in the heart of Jodhpur."
  },
  {
    icon: <FaCertificate />,
    text: "Fully approved by the NCTE & affiliated with JNVU."
  },
  {
    icon: <FaChalkboardTeacher />,
    text: "Dedicated to shaping the future of education via our B.Ed. program."
  }
];

function HomeAbout() {
  return (
    <section className="home-about-section">
      <div className="home-about-container">
        <div className="home-about-grid-layout">
          
          {/* === LEFT COLUMN (HEADING + IMAGE) === */}
          <div className="home-about-left-column">
            <div className="home-about-heading-block">
              <h4 className="home-about-subtitle">Our Foundation</h4>
              <h2 className="home-about-title">About SK TT College</h2>
            </div>
            <div className="home-about-image-wrapper">
              <img 
                src={img} 
                alt="Campus of SK TT College" 
                className="home-about-college-image"
              />
            </div>
          </div>
          
          {/* === RIGHT COLUMN (PREVIEW + REDIRECT) === */}
          <div className="home-about-right-column">
            <h3 className="home-about-content-heading">A Legacy of Empowerment Since 2008</h3>
            <p className="home-about-lead-text">
              Sucheta Kriplani Teacher Training College stands as a beacon of learning, established to provide exceptional and accessible education. Our core mission is to develop the next generation of inspiring educators who will build a stronger tomorrow.
            </p>
            
            <ul className="home-about-key-points">
              {keyPoints.map((point, index) => (
                <li key={index}>
                  <span className="key-point-icon">{point.icon}</span>
                  {point.text}
                </li>
              ))}
            </ul>
            
            <NavLink to="/about" className="home-about-cta-button">
              Discover Our Full Story
            </NavLink>
          </div>

        </div>
      </div>
    </section>
  );
}

export default HomeAbout;